 // Get the modal
var wert = document.getElementById("myWert");

// Get the button that opens the modal
var ratyBtn = document.getElementById("ratyBtn");

// Get the <span> element that closes the modal
var close_top = document.getElementById("close_top");

// Get the <span> element that closes the modal
var close_bottom = document.getElementById('close_bottom');

// When the user clicks the button, open the modal 
ratyBtn.onclick = function () {
    wert.style.display = "block";
}

// When the user clicks on <span> (x), close the modal
close_top.onclick = function () {
    wert.style.display = "none";
}

// When the user clicks on close_bottom, close the modal
close_bottom.onclick = function () {
    wert.style.display = "none";
}    

// When the user clicks anywhere outside of the modal, close it
window.onclick = function (event) {
    if (event.target == wert) {
        wert.style.display = "none";
    }
}
